import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Button, ButtonWithSpinner, CardTitle, Drawer, Text } from '@reveni-io/reveni-ui'

import AmendRejectedLineItem from './AmendRejectedLineItem/AmendRejectedLineItem'
import AmendRejectedOptions from './AmendRejectedOptions/AmendRejectedOptions'
import { amendSelectionStatuses } from './constants'
import * as Styles from './styles'

const AmendRejectedDrawer = ({
  show,
  onClose,
  onAmendRejected,
  amendingRejected,
  rejectedItems,
  itemSelections,
  onSelectItem,
  amendedCount,
  notifyCustomer,
  onChangeNotifyCustomer,
  allowManageRestock,
  restockValue,
  onChangeRestock,
  locations,
  selectedLocation,
  onChangeLocation,
  provider,
  storeId,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const totalCount = rejectedItems?.length || 0

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle marginBottom={theme.spacing.sp24}>{t('Corregir productos rechazados')}</CardTitle>
      <Styles.Container>
        <Text type="bodyMRegular" color={theme.colors.text.muted}>
          {t('Selecciona los productos rechazados que quieres corregir y marcar como aceptados')}
        </Text>
        <Styles.LineItemsContainer>
          {rejectedItems?.map(item => (
            <AmendRejectedLineItem
              key={item.id}
              lineItem={item}
              isAmended={itemSelections[item.id] === amendSelectionStatuses.amended}
              onSelect={status => onSelectItem(item.id, status)}
            />
          ))}
        </Styles.LineItemsContainer>
        <AmendRejectedOptions
          amendedCount={amendedCount}
          totalCount={totalCount}
          allowManageRestock={allowManageRestock}
          restockValue={restockValue}
          onChangeRestock={onChangeRestock}
          locations={locations}
          selectedLocation={selectedLocation}
          onChangeLocation={onChangeLocation}
          provider={provider}
          storeId={storeId}
          notifyCustomer={notifyCustomer}
          onChangeNotifyCustomer={onChangeNotifyCustomer}
        />
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Corregir productos')}
            loadingLabel={t('Corrigiendo')}
            onClick={onAmendRejected}
            loading={amendingRejected}
            disabled={amendedCount === 0 || amendingRejected}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Drawer>
  )
}

export default AmendRejectedDrawer
